export const formatDateWithMonthGenitive = (created_at: string | undefined, t: any) => {
  const monthNamesGenitive = [
    'months.january',
    'months.february',
    'months.march',
    'months.april',
    'months.may',
    'months.june',
    'months.july',
    'months.august',
    'months.september',
    'months.october',
    'months.november',
    'months.december',
  ]

  const getMonthByIndex = (monthNumber: number) => monthNamesGenitive[monthNumber - 1]

  const days = created_at?.split('T')[0].split('-')[2]
  const month = created_at?.split('T')[0].split('-')[1]
  const year = created_at?.split('T')[0].split('-')[0]

  const split_time = created_at?.split('T')[1] || ''
  const time = split_time.split(':')

  return `${Number(days)} ${t(getMonthByIndex(Number(month)))} ${Number(year)}, ${+time[0] + 3}:${time[1]}`
}
